<template>
    <div class="search_select">
        <el-select
                class="select"
                v-model="labelValue"
                multiple
                filterable
                remote
                allow-create
                clearable
                default-first-option
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="remoteMethod"
                @focus="focusRequest"
                @change="change"
                :loading-text="loadingText"
                :loading="loading">
            <el-option
                    v-for="item in options"
                    :key="item"
                    :label="item"
                    :value="item">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    export default {
        name: "SearchSelectCreate",
        props: {
            subjectId: {
                type: Number
            },
            value: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data () {
            return {
                loading: false,
                loadingText: '加载中',
                labelValue: this.value,
                oldValue: '',
                options: []
            }
        },
        watch: {
            labelValue (newV, oldV) {
                this.$emit('input', newV);
                this.oldValue = oldV;
            },
            value (newV) {
                this.labelValue = newV
            }
        },
        methods: {
            change (value) {
                setTimeout(() => {
                    this.$emit('change', value, this.oldValue)
                }, 1)
            },
            focusRequest () {
                this.loading = true;
                this.loadingText = '加载中'
                this.options = [];
                this.$https.post(`/api/tk/label/search`, {
                    query: '',
                    subjectId: this.subjectId
                }).then((response)=>{
                    if (response.data && Array.isArray(response.data)) {
                        this.options = response.data;
                    }
                    if (this.options.length) {
                        this.loading = false;
                    } else {
                        this.loadingText = '暂无数据'
                        // setTimeout(() => {
                        //     this.loading = false;
                        //     this.loadingText = '加载中'
                        // }, 1000)
                    }
                },(error) => {
                    this.loading = false;
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50
                    });
                }).catch(errors => {
                    this.loading = false;
                    this.$errorLog(errors)
                })
            },
            remoteMethod (value) {
                this.loading = true;
                this.loadingText = '加载中'
                this.options = [];
                this.$https.post(`/api/tk/label/search`, {
                    query: value,
                    subjectId: this.subjectId
                }).then((response)=>{
                    if (response.data && Array.isArray(response.data)) {
                        this.options = response.data;
                    }
                    this.loading = false;
                },(error) => {
                    this.loading = false;
                    this.$notify.error({
                        title: '错误',
                        message: error.message || error.data.message,
                        offset: 50
                    });
                }).catch(errors => {
                    this.loading = false;
                    this.$errorLog(errors)
                })
            },
            moveLabel () {
                this.labelValue = []
            }
        }
    }
</script>

<style lang="scss" scoped>
    .search_select{
        .select{
            width: 100%;
            /deep/ .el-tag{
                background: #FFAB00;
                border: none;
                border-radius: 14px;
                font-size: 16px;
                color: white;
                line-height: 24px;
                padding: 0 6px;
                .el-tag__close{
                    background: #FFAB00;
                    right: 0;
                    margin-left: 5px;
                    transform: none;
                    color: #FFAB00;
                    font-size: 16px;
                    text-align: center;
                    line-height: 16px;
                }
                .el-icon-close:before{
                    transform: none;
                    content: "\E79D";
                    color: white;
                }
            }
        }
    }
</style>
